import React from "react";
import BrandLogo from "./BrandLogo";
import "./StripeWaitScreen.css";

/**
 * The "we're working on it" screen for the Stripe round trip.
 *
 * Why this exists (build 41 black-screen fix): the Stripe hand-off pages used
 * to render a bare `<p class="stripe-status">` — #555 text, no background. No
 * CSS in this app paints `body`, and capacitor.config sets no webview
 * background, so on an iOS phone in dark mode the page behind that `<p>` is
 * `UIColor.systemBackground` = pure black. Dark-grey text on black reads as an
 * ENTIRELY BLANK BLACK SCREEN — which is exactly what a talent reported after
 * finishing Stripe. Anything that can hold the screen has to look deliberate,
 * so this paints its own brand surface with the same pulsing wordmark as the
 * boot loader (components/Loader) and says what is happening in readable text.
 */
const StripeWaitScreen: React.FC<{ message: string }> = ({ message }) => (
  <div className="stripe-wait">
    <BrandLogo variant="light" alt="" className="stripe-wait-logo" />
    <p className="stripe-wait-message">{message}</p>
  </div>
);

export default StripeWaitScreen;
